import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
} from '@/components/ui/select';
import type { QueryOrderBy } from '../types/query.types';

export interface QueryOrderRowProps {
  order: QueryOrderBy;
  columns: { name: string }[];
  onChange: (next: QueryOrderBy) => void;
  onRemove: () => void;
}

export function QueryOrderRow({ order, columns, onChange, onRemove }: QueryOrderRowProps) {
  return (
    <div className="flex items-center gap-2">
      <Select value={order.column} onValueChange={(column) => onChange({ ...order, column })}>
        <SelectTrigger data-testid="order-column" className="w-40">
          <SelectValue placeholder="Column" />
        </SelectTrigger>
        <SelectContent>
          {columns.map((c) => (
            <SelectItem key={c.name} value={c.name}>{c.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={order.direction ?? 'asc'}
        onValueChange={(d) => onChange({ ...order, direction: d as 'asc' | 'desc' })}
      >
        <SelectTrigger data-testid="order-direction" className="w-28">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="asc">asc</SelectItem>
          <SelectItem value="desc">desc</SelectItem>
        </SelectContent>
      </Select>
      <Button variant="ghost" size="icon" data-testid="order-remove" onClick={onRemove}>
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
